import { render, staticRenderFns } from "./SortingConstructor.vue?vue&type=template&id=e30f64b8"
import script from "./SortingConstructor.vue?vue&type=script&lang=js"
export * from "./SortingConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e30f64b8')) {
      api.createRecord('e30f64b8', component.options)
    } else {
      api.reload('e30f64b8', component.options)
    }
    module.hot.accept("./SortingConstructor.vue?vue&type=template&id=e30f64b8", function () {
      api.rerender('e30f64b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sorting-constructor/SortingConstructor.vue"
export default component.exports